var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo } from 'react';
import { useAvailableCurrenciesAPI } from '../orgConfigWizard/financials/selectors';
import { isCurrencySupported, useAvailableCurrencyOptions, withCurrentCurrencyOption, withCustomCurrencyOptions } from './useCurrencyOptions';
export var useRollupAvailableCurrencies = function (rollupCurrency, opts) {
  var _a, _b;
  if (opts === void 0) {
    opts = {};
  }
  var configVersionId = opts.configVersionId,
    extraSupportedCodes = opts.extraSupportedCodes;
  var base = (rollupCurrency !== null && rollupCurrency !== void 0 ? rollupCurrency : '').trim().toUpperCase();
  var _c = useAvailableCurrenciesAPI(base || undefined, configVersionId),
    data = _c[0],
    fetch = _c[1];
  var availableCodes = (_a = data.data) === null || _a === void 0 ? void 0 : _a.currencies;
  var customCodes = useMemo(function () {
    var _a, _b;
    var codes = new Set(__spreadArray(__spreadArray([], (_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a.customCurrencies) !== null && _b !== void 0 ? _b : [], true), extraSupportedCodes !== null && extraSupportedCodes !== void 0 ? extraSupportedCodes : [], true));
    return Array.from(codes);
  }, [(_b = data.data) === null || _b === void 0 ? void 0 : _b.customCurrencies, extraSupportedCodes]);
  var baseOptions = useAvailableCurrencyOptions(availableCodes);
  var options = useMemo(function () {
    return withCustomCurrencyOptions(baseOptions, customCodes);
  }, [baseOptions, customCodes]);
  useEffect(function () {
    if (base) {
      fetch();
    }
  }, [base, fetch]);
  var optionsForValue = function (currentCode) {
    return withCurrentCurrencyOption(options, currentCode);
  };
  return {
    availableCodes: availableCodes,
    customCodes: customCodes,
    options: options,
    optionsForValue: optionsForValue,
    /** Re-run the available-currencies fetch, e.g. after an org financials save changes usage. */
    refetch: fetch,
    requesting: Boolean(data.requesting),
    error: data.error,
    isSupported: function (code) {
      return isCurrencySupported(code, availableCodes, customCodes);
    }
  };
};